import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { de } from '../../lib/i18n/de';

/**
 * Dezenter Footer für alle Routen.
 *
 * Enthält ein kleines visuelles DSGVO-Siegel (ShieldCheck-Icon + Datenstandort-
 * Hinweis), den Operator-Vermerk sowie Skelett-Links zu Datenschutz und
 * Impressum. Editorial-Stil: dünner Trennstrich, tracking-widest Mikro-Labels,
 * keine farbigen Akzente.
 */
export function Footer() {
  return (
    <footer className="mt-24 border-t border-stone-200 bg-white">
      <div className="mx-auto max-w-3xl px-5 py-10 md:px-8">
        {/* DSGVO-Siegel — visueller Vertrauensanker */}
        <div className="inline-flex items-center gap-2 rounded-sm border border-stone-200 bg-stone-50 px-3 py-2">
          <ShieldCheck size={14} className="text-emerald-700" aria-hidden="true" />
          <p className="font-sans text-xs font-medium uppercase tracking-widest text-stone-700">
            {de.footer.dataLocation}
          </p>
        </div>
        <p className="mt-4 font-serif text-sm italic text-stone-500">{de.footer.operator}</p>
        <nav className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2">
          <Link
            to="/datenschutz"
            className="font-sans text-xs font-medium uppercase tracking-widest text-stone-700 hover:text-stone-900 hover:underline"
          >
            {de.footer.privacyLink}
          </Link>
          <Link
            to="/impressum"
            className="font-sans text-xs font-medium uppercase tracking-widest text-stone-700 hover:text-stone-900 hover:underline"
          >
            {de.footer.imprintLink}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
